import {App} from "@capacitor/app";

export async function onResume(fn: () => void) {
  await App.addListener("resume", () => fn())
}
